export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/trendingDown.8d2e8453.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};